<div class="spinner-div">
    <mat-spinner class="spinner"></mat-spinner>
    <h3 class="title">
        {{data.msg}}
    </h3>
</div>